import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "col-12 col-sm-12 col-md-4 col-lg-6 col-xl-6" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-body d-flex align-items-center flex-row gap-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "symbol symbol-60px p-3",
  style: {"background":"var(--bs-magenta2)"}
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "bi bi-filetype-pdf fs-3x",
    style: {"color":"var(--bs-magenta)"}
  })
], -1)
const _hoisted_5 = { class: "fs-5 flex-fill" }
const _hoisted_6 = { class: "m-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "fw-normal m-0" }, /*#__PURE__*/_toDisplayString('Normativa oficial de los juegos'), -1)
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VisorFile = _resolveComponent("VisorFile")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.fileTitle), 1),
            _hoisted_7
          ]),
          (_ctx.buttons)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.buttons, (btn, index) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: `btn-${index}`,
                  type: "button",
                  class: "btn btn-sm btn-navy",
                  onClick: ($event: any) => (_ctx.handlerFile(btn?.id))
                }, _toDisplayString(btn?.name), 9, _hoisted_8))
              }), 128))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn btn-sm btn-navy rounded-pill",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handlerFile('')))
              }, _toDisplayString(_ctx.method == 'download' ? _ctx.t('download') : _ctx.t("viewFile")), 1))
        ])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode(_component_VisorFile)
  ], 64))
}